import { render, staticRenderFns } from "./TgHomeRange.vue?vue&type=template&id=45ccf1f9&"
import script from "./TgHomeRange.vue?vue&type=script&lang=js&"
export * from "./TgHomeRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports